import script from "./LegalDocumentContent.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalDocumentContent.vue?vue&type=script&setup=true&lang=js"

import "./LegalDocumentContent.vue?vue&type=style&index=0&id=59ffe31b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59ffe31b"]])

export default __exports__